export default function DataSettings({ subMenu }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Projets & Données</h3>
      <p className="text-gray-500">Gestion des données et synchronisation - En développement...</p>
    </div>
  );
}
